import { useContext } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import UsersContext from "../Context/UsersContext";
import FarmerDetails from "../Farmer/FarmerDetails";
import DataContext from "../Context/DAtaContext";

export default function FarmerOverlay({ open, setOpen, FarmerId }) {
  const { users, farmers } = useContext(UsersContext);
  const { Villages, Payment, Zones } = useContext(DataContext);
  const { vegetableBundle, farmerbundle } = useContext(DataContext);

  const farmer = farmers?.filter((dt) => dt.id === FarmerId);
  const Vano = users?.filter((dt) => dt.id === farmer[0]?.creator_id);
  const FPayment = Payment?.filter((dt) => dt?.farmer_id === farmer[0]?.uuid);
  const FVillage = Villages?.filter((dt) => dt?.id === farmer[0]?.village_id);
  const Zone = Zones?.filter((dt) => dt?.id === FVillage[0]?.zone_id);

  const FBundle = farmerbundle?.filter(
    (dt) => dt?.farmer_id === farmer[0]?.uuid,
  );
  const VNvlla = FBundle?.map((Fbundle) => {
    return vegetableBundle?.filter(
      (VgBundle) => VgBundle?.id === Fbundle?.bundle_id,
    );
  });

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="fixed inset-0 z-50 overflow-y-auto"
    >
      {/* Backdrop */}
      <DialogBackdrop
        className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75 backdrop-blur-sm dark:bg-black/50"
        enter="transition-opacity ease-linear duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      />

      {/* Overlay panel */}
      <div className="flex items-center justify-center min-h-screen px-4 text-center sm:block sm:p-0">
        <DialogPanel
          className="relative inline-block w-full max-w-6xl my-20 overflow-hidden text-left align-middle transition-all transform shadow sm:align-middle"
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {/* Content */}
          <div className=" sm:px-20 xl:w-full">
            {/* Farmer Details */}
            <FarmerDetails
              FVillage={FVillage}
              Vano={Vano}
              farmer={farmer}
              zone={Zone}
              setOpen={setOpen}
              FBundle={FBundle}
              FPayment={FPayment}
              FPackage={VNvlla.flat()}
            />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
